var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUsageSkeletonMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 335 1309"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "url(#usage-skeleton-mobile_svg__b)",
  clipPath: "url(#usage-skeleton-mobile_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 50,
  rx: 25
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 50,
  y: 148,
  rx: 25
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 50,
  y: 74,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 40.182,
  y: 230,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 40.182,
  y: 280.182,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 40.182,
  y: 330.364,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 40.182,
  y: 380.545,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 40.182,
  y: 430.727,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 40.182,
  y: 480.909,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 40.182,
  y: 531.091,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 40.182,
  y: 581.273,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 40.182,
  y: 631.455,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 40.182,
  y: 681.636,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 40.182,
  y: 731.818,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 421,
  y: 888,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 95,
  height: 44,
  x: 120,
  y: 812,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 24,
  x: 255,
  y: 822,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 24,
  y: 822,
  rx: 5
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "usage-skeleton-mobile_svg__b",
  x1: 0,
  x2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "stop-color",
  dur: "1s",
  repeatCount: "indefinite",
  values: "white; #F7F7F7; white;"
})), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7F7F7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "stop-color",
  dur: "1s",
  repeatCount: "indefinite",
  values: "#F7F7F7; white; #F7F7F7;"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "gradientTransform",
  dur: "3s",
  from: "0 0 0",
  repeatCount: "indefinite",
  to: "0 0 0",
  type: "translate"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "usage-skeleton-mobile_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h335v1309H0z"
})))));
export { SvgUsageSkeletonMobile as ReactComponent };
export default __webpack_public_path__ + "static/media/usage-skeleton-mobile.f7046486a3315637a37e.svg";